// NOTE: this is applied at query factory level, not base filters level,

import type { estypes } from '@elastic/elasticsearch';

// so we still need to include `query` as the top level key
export const hitRateRequiredQueryFactory = ({ hitRateBucket = 'last10' } = {}): estypes.QueryDslQueryContainer => ({
  bool: {
    must: [
      {
        exists: {
          field: `sportsData.hitRates.${hitRateBucket}`,
        },
      },
    ],
    must_not: [
      {
        term: {
          [`sportsData.hitRates.${hitRateBucket}`]: 0,
        },
      },
    ],
  },
});
